import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { TrendingUp, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { apiError, fmtDate } from "@/lib/format";
import { PageHeader, EmptyState } from "@/components/Page";

const today = () => new Date().toISOString().slice(0, 10);

export default function Projektstunden() {
  const [projects, setProjects] = useState([]);
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ project_id: "", date: today(), hours: "", note: "" });

  const load = async () => {
    try {
      const [p, t] = await Promise.all([api.get("/my/projects"), api.get("/my/project-time")]);
      setProjects(p.data || []); setRows(t.data || []);
      setForm((f) => ({ ...f, project_id: f.project_id || (p.data?.[0]?.id || "") }));
    } catch (e) { toast.error(apiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!form.project_id) return toast.error("Bitte Projekt wählen");
    if (!form.hours) return toast.error("Bitte Stunden eingeben");
    try { await api.post("/my/project-time", { ...form, hours: parseFloat(form.hours) }); toast.success("Stunden gebucht"); setForm({ ...form, hours: "", note: "" }); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => { try { await api.delete(`/my/project-time/${id}`); load(); } catch (e) { toast.error(apiError(e)); } };

  return (
    <div>
      <PageHeader title="Projektstunden" subtitle="Buche deine Arbeitszeit am Tagesende auf ein Projekt." testid="projektstunden-header" />
      <Card className="p-5 border-slate-200 rounded-xl">
        <div className="grid sm:grid-cols-4 gap-3">
          <div className="sm:col-span-2">
            <label className="text-sm text-slate-600">Projekt</label>
            <Select value={form.project_id} onValueChange={(v) => setForm({ ...form, project_id: v })}>
              <SelectTrigger data-testid="myproj-select"><SelectValue placeholder="Projekt wählen" /></SelectTrigger>
              <SelectContent>{projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.project_no} · {p.title} ({p.customer_name})</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><label className="text-sm text-slate-600">Datum</label><Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} data-testid="myproj-date" /></div>
          <div><label className="text-sm text-slate-600">Stunden</label><Input type="number" placeholder="z. B. 3.5" value={form.hours} onChange={(e) => setForm({ ...form, hours: e.target.value })} data-testid="myproj-hours" /></div>
        </div>
        <Input className="mt-3" placeholder="Notiz (optional)" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} data-testid="myproj-note" />
        <Button onClick={submit} data-testid="myproj-add" className="brand-bg text-white hover:opacity-90 mt-3"><Plus className="h-4 w-4 mr-1" /> Stunden buchen</Button>
      </Card>

      <h3 className="font-semibold text-slate-800 mt-6 mb-2">Meine Buchungen</h3>
      {rows.length === 0 ? (
        <Card className="border-slate-200 rounded-xl"><EmptyState icon={TrendingUp} title="Noch keine Buchungen" testid="myproj-empty" /></Card>
      ) : (
        <div className="grid gap-2">
          {rows.map((x) => (
            <Card key={x.id} className="p-3 border-slate-200 rounded-xl flex items-center justify-between" data-testid={`myproj-${x.id}`}>
              <div className="text-sm">
                <span className="font-medium text-slate-800">{x.project_no} · {x.project_title}</span>
                <div className="text-xs text-slate-500">{fmtDate(x.date)} · {x.hours} h{x.note ? ` · ${x.note}` : ""}</div>
              </div>
              <button onClick={() => del(x.id)} className="text-slate-300 hover:text-rose-500" data-testid={`myproj-del-${x.id}`}><Trash2 className="h-4 w-4" /></button>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
